import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isValidLanguage, saveLanguagePreference } from '../../i18n/utils/languageUtils';

const LanguageRoute = ({ path }: { path: string }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const [language] = path.split('/*');
    if (isValidLanguage(language)) {
      saveLanguagePreference(language);
      i18n.changeLanguage(language).then(() => {
        const remainder = location.pathname.slice(language.length + 1) || '/';
        navigate(remainder, { replace: true });
      });
    } else {
      navigate('/', { replace: true });
    }
  }, [i18n, location.pathname, navigate, path]);

  return null;
};

export default LanguageRoute;
